import { getXStateConfigWoofzInt1 } from 'cohorts/intl_1/getXStateConfigIntl1'
import { getXStateConfigWoofzInt1T } from 'cohorts/intl_1t/getXStateConfigIntl1T'
import { getXStateConfigWoofzInt2 } from 'cohorts/intl_2/getXStateConfigIntl2'
import { getXStateConfigWoofzInt2Lw } from 'cohorts/intl_2lw/getXStateConfigIntl2Lw'
import { getXStateConfigWoofzIntD60 } from 'cohorts/intl_d60/getXStateConfigIntlD60'
import { getXStateConfigWoofzIntD70 } from 'cohorts/intl_d70/getXStateConfigIntlD70'
import { getXStateConfigWoofzIntlHlwn70 } from 'cohorts/intl_hlwn70/getXStateConfigIntlHlwn70'
import { getXStateConfigIntlMw } from 'cohorts/intl_mw/getXStateConfigIntlMw'
import { getXStateConfigWoofzInt3 } from 'cohorts/intl_3/getXStateConfigIntl3'
import { Cohort } from 'root-constants'
import type { TStep } from 'src/types'
import type { StatesConfig } from 'xstate'

export const XSTATE_CONFIGS_MAP: Record<
  Cohort,
  (pages: TStep[]) => StatesConfig<any, any, any>
> = {
  [Cohort.INTL_1]: getXStateConfigWoofzInt1,
  [Cohort.INTL_1T]: getXStateConfigWoofzInt1T,
  [Cohort.INTL_2]: getXStateConfigWoofzInt2,
  [Cohort.INTL_2LW]: getXStateConfigWoofzInt2Lw,
  [Cohort.INTL_D60]: getXStateConfigWoofzIntD60,
  [Cohort.INTL_D70]: getXStateConfigWoofzIntD70,
  [Cohort.INTL_HLWN70]: getXStateConfigWoofzIntlHlwn70,
  [Cohort.INTL_MW]: getXStateConfigIntlMw,
  [Cohort.INTL_3]: getXStateConfigWoofzInt3,
}
